<template>
    <v-dialog
        v-model="dialog"
        @click:outside="closeDialog"
        fullscreen
        scrollable
        z-index="210"
    >
        <v-card >
            <v-toolbar dense :elevation="0" style="max-height: 48px;">
                <v-toolbar-title class="text-primary-700">{{ entity.name }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0" style="position: relative; min-height: 600px;">
                <div style="position: absolute; padding: 10px; padding-right: 50px; z-index: 1; display: flex; flex-wrap: wrap; row-gap: 10px; width: 100%; pointer-events: none;">
                    <v-tooltip v-if="!showRPDMarkers" bottom>
                        <template v-slot:activator="{ on }">
                            <div class="mr-3" v-on="on" style="margin-left: 180px; background-color: white; border-radius: 2px;">
                            <v-btn target="_blank" depressed disabled class="py-4 pl-3 pr-4 map-property" color="grey lighten-2" style="pointer-events: all;">
                                <v-icon color="primary" style="font-size: large;">mdi-home-plus</v-icon>
                                <span class="ml-1" style=" font-weight: 500;">New Property/Scheme</span>
                            </v-btn>
                            </div>
                        </template>
                        <span>To avoid creating duplicate properties, you must enable `Show RPD Markers` first.</span>
                    </v-tooltip>

                    <v-menu v-else-if="!placingMarker" offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn target="_blank" v-on="on" depressed class="py-4 pl-3 pr-4 mr-3 map-property" color="white" style="margin-left: 180px; pointer-events: all;">
                            <v-icon color="primary" style="font-size: large;">mdi-home-plus</v-icon>
                            <span class="ml-1" style=" font-weight: 500;">New Property/Scheme</span>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="addProperty">
                            <v-list-item-title>New Standalone Property</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="addProperty('scheme')">
                            <v-list-item-title>New Scheme</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>


                    <v-btn v-else target="_blank" @click="placingMarker = false"  depressed class="py-4 pl-3 pr-4 mr-3 map-property" color="grey lighten-3" style="margin-left: 180px; pointer-events: all;">
                        <v-icon style="font-size: large;">mdi-crosshairs</v-icon>
                        <span class="ml-1" style=" font-weight: 500;">Click Map to Select Location</span>
                    </v-btn>

                    <v-btn @click="toggleMatching" depressed class="py-4 pl-3 pr-4 mr-3 map-property" color="white" style="pointer-events: all;">
                        <template v-if="!hideMatching" >
                            <v-icon color="primary" style="font-size: large;">mdi-eye-off</v-icon>
                            <span class="ml-1" style=" font-weight: 500;">Hide Matching</span>
                        </template>

                        <template v-else>
                            <v-icon  color="primary" style="font-size: large;">mdi-eye</v-icon>
                            <span class="ml-1"style=" font-weight: 500;">Show Matching</span>
                        </template>
                    </v-btn>

                    <v-card style=" border-radius: 2px;box-shadow: 0 0 6px 0 rgba(0,0,0,0.3);">
                        <v-card-title class="py-1">
                            <span class="font-weight-light text-overline">Matched: {{ matchedMarkers.length }}</span>
                        </v-card-title>
                    </v-card>

                    <v-spacer></v-spacer>

                    <div class="mr-3 ml-0" style="margin-left: 180px; background-color: white; border-radius: 10000px; width: 40px; min-width: 40px">
                        <v-btn class="pa-0 map-property" style="pointer-events: all; border-radius: 10000px; width: 40px; min-width: 40px" @click="undoEdit" :disabled="editHistoryIndex === -1 || editHistory.length === 0">
                            <v-icon color="primary" style="font-size: x-large;">mdi-undo-variant</v-icon>
                        </v-btn>
                    </div>

                    

                    <div class="mr-3 ml-0" style="margin-left: 180px; background-color: white; border-radius: 10000px; width: 40px; min-width: 40px">
                        <v-btn class="pa-0 map-property" style="pointer-events: all; border-radius: 10000px; width: 40px; min-width: 40px" @click="redoEdit" :disabled="editHistoryIndex === editHistory.length - 1 || editHistory.length === 0">
                            <v-icon color="primary" style="font-size: x-large;">mdi-redo-variant</v-icon>
                        </v-btn>
                    </div>

                    <v-btn @click="showRPDMarkers = !showRPDMarkers" depressed class="py-4 pl-3 pr-4 mr-3 map-property" color="white" style="pointer-events: all;">
                        <template v-if="showRPDMarkers" >
                            <v-icon color="primary" style="font-size: large;">mdi-eye-off</v-icon>
                            <span class="ml-1" style=" font-weight: 500;">Hide RPD Markers</span>
                        </template>

                        <template v-else>
                            <v-icon  color="primary" style="font-size: large;">mdi-eye</v-icon>
                            <span class="ml-1"style=" font-weight: 500;">Show RPD Markers</span>
                        </template>
                    </v-btn>    
                </div>

                <GmapMap
                    :center="{lat: 52.5072, lng: -1.1276}"
                    :zoom="6"
                    ref="map"
                    style="width: 100%; height: 100%"
                    :options="mapOptions"
                    @click="addMarker"
                >
                    <GmapMarker v-if="propertyMarker && placingMarker"
                        :position="propertyMarker"
                        :clickable="true"
                        :draggable="true"
                        @dragend="dragPropertyMarker"
                        />

                </GmapMap>

                <!-- for testing -->
                <!-- <v-card style="position: absolute; bottom: 404px; left:70px; min-width: 300px;">
                    <v-card-text style="min-height: 86px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                         
                        <v-card v-for="(marker) in editHistory" :elevation="1" :color="markerIndex === editHistory.indexOf(marker) ? 'primary' : 'white'" class="mb-2" style="width: 100%;" :key="editHistory.indexOf(marker)">
                            <v-card-text>
                            {{ marker.type == 'scraped' ? 'Scraped' : 'Retailer' }}
                            {{ marker.type == 'scraped' ? {lat: marker.oldMarker.marker.lat, lng: marker.oldMarker.marker.lng} : marker.oldMarker.marker.position }}
                            <v-divider></v-divider>
                            {{ marker.type == 'scraped' ? 'Scraped' : 'Retailer' }}
                            {{ marker.type == 'scraped' ? {lat: marker.newMarker.marker.lat, lng: marker.newMarker.marker.lng} : marker.newMarker.marker.position }}
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card> -->

                <v-card v-if="placingMarker" style="position: absolute; bottom: 24px; right:70px; min-width: 300px;">
                    <v-card-text style="min-height: 86px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                    <!-- <template v-if="addressLoading">
                        <v-skeleton-loader style="width: 100%;" class="address-loader"  type="list-item-two-line"></v-skeleton-loader>
                    </template> -->
                    <template v-if="!propertyMarker">
                        <div style="width: 100%; display: flex; align-items: center;">
                        <span class="text-center text-overline">Click on the map to select a location</span>
                        <v-spacer></v-spacer>
                        <v-btn class="ml-2 mr-0" width="25" height="25" icon @click="placingMarker = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        </div>

                    </template>
                    <template v-else-if="validAddress">
                        <div style="width: 100%; display: flex; align-items: center;">
                        <span v-if="propertyAddress.line1" class="text-h6">{{ propertyAddress.line1 }}</span>
                        <span v-else style="width: 100%;">{{ compiledAddress }}</span>
                        <v-spacer></v-spacer>
                        <v-btn class="ml-2 mr-0" width="25" height="25" icon @click="placingMarker = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        </div>
                        <span v-if="propertyAddress.line1" style="width: 100%;">{{ compiledAddress }}</span>
                    </template>
                    <template v-else>
                        <div style="width: 100%; display: flex; align-items: center;">
                        <span class="text-center text-overline">Invalid Location</span>
                        <v-spacer></v-spacer>
                        <v-btn class="ml-2 mr-0" width="25" height="25" icon @click="placingMarker = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        </div>

                    </template>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed @click="clearPropertyMarker">Clear</v-btn>
                        <v-btn color="primary" :disabled="!validAddress" depressed @click="selectAddress">Select Address</v-btn>
                    </v-card-actions>
                </v-card>

                <div style="position: absolute; bottom: 24px; left:24px; width: 430px; overflow: hidden; display: flex; flex-direction: column;">
                <v-card v-if="showList" style="overflow:hidden">
                        <!-- search bar -->
                         <v-card-title class="pa-0 pb-1">
                            <v-text-field
                                class="pt-0 mt-0"
                                filled
                                dense
                                v-model="searchQuery"
                                label="Search Retailers"
                                prepend-inner-icon="mdi-magnify"
                                color="primary"
                                single-line
                                clearable
                                hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-card-text class="pa-0">
                            <v-list-item-group v-if="searchListData.length" class="unmatched-scraped-data" style="max-height: 300px; overflow-y: auto;" @change="jumpToMarker(markerIndex)">
                                <v-list-item v-for="(marker) in searchListData" @click="markerIndex = marker.index">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ marker.name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ marker.address }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <!-- if marker has already been matched -->
                                    <v-list-item-action v-if="matchedMarkers.find(item => item.scrapedId === marker.id)">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-icon color="green lighten-3" v-on="on">mdi-map-marker-plus</v-icon>
                                            </template>
                                            This retailer has been matched.
                                        </v-tooltip>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list-item-group>
                            <v-list-item class="py-4" v-else>
                                <v-list-item-content>
                                    <v-list-item-title class="text-center grey--text darken-3">No Retailers Found</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>
                    </v-card>

                    <v-card class="mt-4" v-if="scraperListData.length > 0">
                        
                            <v-card-text style="min-height: 86px;">
                                <!-- list of all markers -->
                                
                                <h3 class="text-h6">{{ scraperListData[markerIndex].name }}</h3>
                                <span>{{ scraperListData[markerIndex].address }}</span>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <span class="ml-2 grey--text">{{ markerIndex + 1 }} / {{ scraperListData.length }}</span>
                                <v-spacer></v-spacer>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <div class="ml-2" v-on="on">
                                            <v-btn icon @click="showList = !showList">
                                                <v-icon :color="showList ? 'primary' : ''">mdi-format-list-bulleted</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span >Show All Scraped Retailers</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <div class="ml-2" v-on="on">
                                            <v-btn icon @click="toggleListMatching()">
                                                <v-icon v-if="hideListMatching">mdi-eye</v-icon>
                                                <v-icon v-else>mdi-eye-off</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span v-if="hideListMatching">Show Matching Retailers</span>
                                    <span v-else>Hide Matching Retailers</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                            <v-btn class="ml-2" v-on="on" icon @click="nextMarker('')">
                                                <v-icon>mdi-map-search</v-icon>
                                            </v-btn>
                                    </template>
                                    <span>Jump to Marker</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <div class="ml-2" v-on="on">
                                            <v-btn icon @click="resetCoords(scraperListData[markerIndex])" :disabled="checkEdits(scraperListData[markerIndex])">
                                                <v-icon>mdi-refresh</v-icon>
                                            </v-btn>
                                        </div>
                                        
                                    </template>
                                    <span>Reset Property to Original Location</span>
                                </v-tooltip>
                                <!-- jump to marker button -->
                                <!-- <v-btn icon @click="nextMarker('')">
                                    <v-icon>mdi-map-marker</v-icon>
                                </v-btn> -->
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <div class="ml-2" v-on="on">
                                            <v-btn icon @click="createMatchedMarker(scraperListData[markerIndex])" :disabled="!showRPDMarkers">
                                                <v-icon>mdi-map-marker-plus</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>Create new RPD Property at this location.<br/><span v-if="!showRPDMarkers">Requires 'Show RPD Markers' to be enabled first.</span></span>
                                </v-tooltip>
                                <v-spacer></v-spacer>
                                <!-- left and right arrows -->
                                <v-btn icon @click="nextMarker('left')">
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                                <v-btn icon @click="nextMarker('right')">
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-card-actions>
                        
                    </v-card>
                </div>

            </v-card-text>
            <v-dialog v-model="editDialog" max-width="600px">
                <v-card>
                    <v-toolbar dense :elevation="0">
                        <v-toolbar-title class="text-primary-700">Set Error for {{ link.name }}</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                        <v-btn style="width: 35px; height: 35px" icon @click="editDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-6">
                        <!-- multiselect with other -->
                         <v-radio-group class="mt-0" v-model="link.error" hide-details>
                            <v-radio class="mb-4" label="No Error" value=""></v-radio>
                            <v-radio class="mb-4" label="Duplicate Link" value="Duplicate Link"></v-radio>
                            <v-row class="mx-0 mt-0 mb-0" align="center">
                                <v-radio class="mb-0" value="Other"></v-radio><v-text-field class="mt-0" placeholder="Other" :disabled="link.error != 'Other'" hide-details v-model="editOther" dense></v-text-field>
                            </v-row>
                        </v-radio-group>
                        
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" depressed @click="saveError">Save</v-btn>
                        </v-card-actions>
                </v-card>
            </v-dialog>
            <add-property-dialog ref="addPropertyDialog" @added="mapAdded"></add-property-dialog>
            <add-scheme-dialog ref="addSchemeDialog" @added="mapAdded"></add-scheme-dialog>
            <edit-property-dialog @updated="refreshData" @deleted="propertyMarkerDeleted" ref="editPropertyDialog"></edit-property-dialog>
            <edit-scheme-dialog @updated="refreshData" @deleted="schemeMarkerDeleted" ref="editSchemeDialog"></edit-scheme-dialog>
        </v-card>
    </v-dialog>
</template>

<script>

import { watch } from 'vue';
import addPropertyDialog from '@/components/properties/addPropertyDialog'
import AddSchemeDialog from '@/components/schemes/addSchemeDialog'
import editPropertyDialog from '@/components/properties/editPropertyDialog'
import editSchemeDialog from '@/components/schemes/editSchemeDialog'
    export default {
        components: {
            addPropertyDialog,
            AddSchemeDialog,
            editPropertyDialog,
            editSchemeDialog
        },

        data(){
            return {
                // Add the following data
                dialog: false,
                loading: false,
                entity: {},
                scrapedData: [],
                hiddenScrapedData: [],
                retailerData: [],
                rpdData: [],
                scrapedMarkers: [],
                retailerMarkers: [],
                rpdMarkers: [],

                markerIndex: 0,
                updateCooldown: false,

                searchQuery: '',

                matchedMarkers: [],

                editHistory: [],
                editHistoryIndex: -1,
                showList: false,

                placingMarker: false,
                addressLoading: false,
                propertyMarker: null,
                propertyAddress: {
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    country: '',
                    zip: ''
                },

                editDialog: false,
                link: {},
                editOther: '',

                hideMatching: true,
                hideListMatching: true,
                showRPDMarkers: false,

                checkpoints:{
                    scrapedData: false,
                    retailerData: false
                },

                infoWindow: null,
                infoWindowExpanded: null,
                mapOptions:{
                    mapTypeId: 'hybrid',
                    gestureHandling: 'greedy',
                    zoomControlOptions: {},
                    streetViewControlOptions: {},
                    circle1InfoWindowOpened: true,
                    circle2InfoWindowOpened: true,
                    styles: [{featureType: "administrative",elementTypefeatureType: "geometry",stylers: [{visibility: "on"}]},{featureType: "administrative.neighborhood",stylers: [{visibility: "on"}]},{featureType: "landscape.man_made",elementType: "labels.icon",stylers: [{weight: 5}]},{featureType: "landscape.natural",elementType: "geometry.fill",stylers: [{color: "#dddde4"}]},{featureType: "poi",stylers: [{visibility: "on"}]},{featureType: "poi",elementType: "labels.icon",stylers: [{visibility: "on"}]},{featureType: "poi",elementType: "geometry.fill",stylers: [{color: "#dad7fe"}]},{featureType: "poi",elementType: "labels.text",stylers: [{visibility: "off"}]},{featureType: "poi.park",elementType: "geometry.fill",stylers: [{visibility: "on"}]},{featureType: "road.highway",elementType: "geometry.fill",stylers: [{color: "#c2c0d3"}]},{featureType: "road.highway",elementType: "geometry.stroke",stylers: [{color: "#9897af"}]},{featureType: "road",elementType: "labels",stylers: [{visibility: "on"}]},{featureType: "road",elementType: "labels.icon",stylers: [{visibility: "on"}]},{featureType: "road.arterial",elementType: "labels",stylers: [{visibility: "on"}]},{featureType: "road.highway",elementType: "labels",stylers: [{visibility: "on"}]},{featureType: "road.local",stylers: [{visibility: "on"}]},{featureType: "road.local",elementType: "geometry.fill",stylers: [{color: "#b8b8bf"},{weight: 3}]},{featureType: "road.local",elementType: "geometry.stroke",stylers: [{visibility: "on"}]},{featureType: "transit",stylers: [{visibility: "on"}]},{featureType: "water",elementType: "geometry.fill",stylers: [{color: "#aeb7f9"}]},{featureType: "water",elementType: "labels.text",stylers: [{visibility: "on"}]}],
                }
            }
        },

        methods: {
            showDialog(entity) {
                this.dialog = true;
                this.entity = entity;
                this.getRetailerLinks(entity.id)
                this.getPropertyMarkers(entity.clientCompany.data.id)
                // next tick
                this.$nextTick(() => {
                    this.$gmapApiPromiseLazy().then(() => {

                        if (this.$store.state.map.satellite) {
                            this.mapOptions.mapTypeId = this.$store.state.map.satellite
                        }else{
                            // satellite
                            this.mapOptions.mapTypeId = 'satellite'
                        }
                        let boundsDebounce;
                        google.maps.event.addListener(this.$refs.map.$mapObject, 'bounds_changed', () => {
                            clearTimeout(boundsDebounce);
                            boundsDebounce = setTimeout(() => {
                                this.mapUpdate()
                            }, 200); 
                        });

                        // stop map drag event
                        google.maps.event.addListener(this.$refs.map.$mapObject, 'dragend', () => {
                            this.updateRPDMarkers()
                        });

                        this.infoWindow = new google.maps.InfoWindow({
                            content: `<div class="custom-info-window">Loading...</div>`,
                        });
                        this.infoWindowExpanded = new google.maps.InfoWindow({
                            content: `<div class="custom-info-window-expanded">Loading...</div>`,
                        });
                        google.maps.event.addListener(this.$refs.map.$mapObject, 'click', (event) => {
                            this.infoWindow.close();
                            this.infoWindowExpanded.close();
                        });

                        const style = document.createElement("style");
                        style.innerHTML = `
                            .gm-ui-hover-effect {
                                display: none !important; /* Hides the close button */
                            }
                            .gm-style-iw-chr{
                                display:none !important;
                            }
                            .gm-style-iw-d{
                                padding: 12px 0 0 0 !important;
                            }
                        `;
                        document.head.appendChild(style);
                    });
                });
                
            },
            closeDialog() {
                 // clear all markers
                 this.clearMarkers()
                 this.clearData()
                this.dialog = false;

            },

            setError(link){
                this.link = JSON.parse(JSON.stringify(link)); // deep copy to avoid mutating original object
                this.editOther = '';

                if (this.link.error && this.link.error !== 'Duplicate Link') {
                    this.editOther = this.link.error;
                    this.link.error = 'Other';
                }
                this.editDialog = true;
            },

            saveError() {
                if (this.link.error == 'Other' && this.editOther.trim() == '') {
                    this.$notify.error("Please enter a valid error message");
                    return;
                }
                this.$http.put(`/scrapers/links/${this.link.id}`, {
                    error: this.link.error == 'Other' ? this.editOther : this.link.error
                })
                .then(response => {
                    this.editDialog = false;
                    this.refreshData();
                })
                .catch(error => {
                    this.$notify.error("Error updating error, if this persists, please contact support")
                    console.log(error);
                });
            },

            undoEdit(){
                if (this.editHistoryIndex >= 0) {
                    const historyItem = this.editHistory[this.editHistoryIndex];
                    if (historyItem.type === 'scraped'){
                        this.dragScrapedMarker(historyItem.oldMarker.marker, historyItem.oldMarker.e, true);
                    }else{
                        this.dragRetailerMarker(historyItem.oldMarker.marker, historyItem.oldMarker.e, true);
                    }

                    this.editHistoryIndex--;
                }
            },

            redoEdit(){
                if (this.editHistoryIndex < this.editHistory.length - 1) {
                    this.editHistoryIndex++;
                    const historyItem = this.editHistory[this.editHistoryIndex];

                    if (historyItem.type === 'scraped'){
                        this.dragScrapedMarker(historyItem.newMarker.marker, historyItem.newMarker.e, true);
                    } else {
                        this.dragRetailerMarker(historyItem.newMarker.marker, historyItem.newMarker.e, true);
                    }
                }
            },

            checkEdits(marker){
                // return false if marker has been edited
                // return !this.editHistory.some(item => item.oldMarker.marker.id === marker.id)
                if (marker.lat != null && marker.lng != null && marker.original_lat != null && marker.original_lng != null) {
                    return (marker.lat == marker.original_lat  && marker.lng == marker.original_lng)
                } else {
                    return true
                }
            },

            createMatchedMarker(marker){
                // open create property dialog with marker data
                this.propertyMarker = {
                    lat: parseFloat(marker.lat),
                    lng: parseFloat(marker.lng),
                };
                this.propertyType = 'property';
                let address = marker.address;

                this.getAddress(true);
                

                // google maps address lookup
                let geocoder = new google.maps.Geocoder();
                geocoder.geocode({address: address}, (results, status) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if(results[0]){
                            const addressComponents = results[0].address_components;

                            this.propertyAddress = {
                                line1: '',
                                line2: '',
                                city: '',
                                state: '',
                                country: '',
                                zip: ''
                            };
                            const getComponent = (type) =>
                            addressComponents.find((component) => component.types.includes(type));

                            // Populate address fields
                            const streetNumber = getComponent('street_number');
                            const route = getComponent('route');
                            const locality = getComponent('locality');
                            const postalTown = getComponent('postal_town');
                            const adminArea = getComponent('administrative_area_level_1'); // State
                            const postalCode = getComponent('postal_code');
                            const country = getComponent('country');

                            // Assign values if the components are found
                            this.propertyAddress.line1 = streetNumber && route
                                ? `${streetNumber.long_name} ${route.long_name}`
                                : route
                                ? route.long_name
                                : '';
                            this.propertyAddress.city = locality ? locality.long_name : postalTown ? postalTown.long_name : '';
                            this.propertyAddress.state = adminArea ? adminArea.long_name : '';
                            this.propertyAddress.zip = postalCode ? postalCode.long_name : '';
                            this.propertyAddress.country = country ? country.long_name : '';
                            this.selectAddress();

                        }
                    } else {
                        this.$notify.error("Error fetching address, if this persists, please contact support")
                        console.log(status);
                    }
                });
               
            },

            async resetCoords(marker){
                // find marker in edit history and restore it to the original position
                // let historyItem = this.editHistory.find(item => item.oldMarker.marker.id === marker.id)
                // if (historyItem){
                //     if (historyItem.type === 'scraped'){
                //         await this.dragScrapedMarker(historyItem.oldMarker.marker, historyItem.oldMarker.e, true);
                //     }else{
                //         await this.dragRetailerMarker(historyItem.oldMarker.marker, historyItem.oldMarker.e, true);
                //     }
                //     // clear all history of that marker from the edit history and decrement the index for each item thats before the current index thats removed
                //     let newHistory = this.editHistory.filter(item => item.oldMarker.marker.id !== marker.id)
                //     let reduceAmount = 0
                //     this.editHistory.map((item, index) => {
                //         if (item.oldMarker.marker.id === marker.id){
                //             if (index < this.editHistoryIndex){
                //                 this.reduceAmount++
                //             }
                //         }
                //     })
                //     this.editHistoryIndex -= reduceAmount
                //     this.editHistory = newHistory
                    
                // }

                this.$http.put(`/scrapers/links/${marker.id}/position`, {
                    lat: marker.original_lat,
                    lng: marker.original_lng
                })
                .then(response => {
                    this.$notify.success("Coordinates reset successfully")
                    this.refreshData()
                })
                .catch(error => {
                    this.$notify.error("Error resetting coordinates, if this persists, please contact support")
                    console.log(error);
                });
            },

            nextMarker(direction){
                // jump to next scraped marker thats not matched
                let scraped = this.scrapedData
                // add index to scraped, then filter out matched markers
                scraped = scraped.map((item, index) => {
                    item.index = index
                    return item
                })
                scraped = scraped.filter(item => !this.hiddenScrapedData.includes(item))
                
                if (direction === 'right'){
                    this.markerIndex = this.markerIndex + 1
                    if (this.markerIndex >= scraped.length){
                        this.markerIndex = 0
                    }
                    
                } else if (direction === 'left'){
                    this.markerIndex = this.markerIndex - 1
                    if (this.markerIndex < 0){
                        this.markerIndex = scraped.length - 1
                    }
                }

               
                this.jumpToMarker(scraped[this.markerIndex].index)
                
            },

            jumpToMarker(index){
                // find marker 
                let marker = this.scrapedData.find((item, i) => i === index)
                this.$refs.map.$mapObject.setCenter({lat: parseFloat(marker.lat), lng: parseFloat(marker.lng)})
                // set zoom to 15
                this.$refs.map.$mapObject.setZoom(15)
            },

            refreshData(){
                this.loading = true
                this.checkpoints = {
                    scrapedData: false,
                    retailerData: false
                }
                this.clearMarkers()
                this.getRetailerLinks(this.entity.id)
                this.getPropertyMarkers(this.entity.clientCompany.data.id)
            },

            getRetailerLinks(retailerID){
                this.checkpoints.scrapedData = false
                this.$http.get('/scrapers/links', {
                    params: {
                        scraper_id: retailerID
                    }
                }).then(response => {
                    this.loading = false
                    this.scrapedData = response.data.data
                    this.checkpoints.scrapedData = true
                }).catch(error => {
                    this.$notify.error("Error fetching map data, if this persists, please contact support")
                    console.log(error)
                })
            },

            getPropertyMarkers(id){
                this.checkpoints.retailerData = false
                this.$http.get('/map/layer/coordinates', {
                    params: {
                        include: 'entity, entity.scheme',
                        tenant_company_id: id
                    }
                }).then(response => {
                    this.loading = false
                    this.retailerData = response.data.data
                    this.checkpoints.retailerData = true
                }).catch(error => {
                    this.$notify.error("Error fetching map data, if this persists, please contact support")
                    console.log(error)
                })
            },

            async getAllMarkers(){
                
                await this.$http.get('/map/coordinates', {
                    params: {
                        entity_type: 'scheme',
                    }
                }).then(response => {
                    this.loading = false
                    this.rpdData = response.data.data
                }).catch(error => {
                    this.$notify.error("Error fetching map data, if this persists, please contact support")
                    console.log(error)
                })

                

                await this.$http.get('/map/coordinates').then(response => {
                    this.loading = false
                    this.rpdData = this.rpdData.concat(response.data.data)

                    let meta = response.data.meta.pagination;
                    if (meta.total_pages > 1) {
                        for (let i = 2; i <= meta.total_pages; i++) {
                            this.$http.get('/map/coordinates', {
                                params: {
                                    // include: 'entity, entity.scheme',
                                page: i,
                                }
                            }).then(response => {
                                this.rpdData = this.rpdData.concat(response.data.data)
                            }).catch(error => {
                                console.log(error)
                            })
                        }
                    }
                }).catch(error => {
                    this.$notify.error("Error fetching map data, if this persists, please contact support")
                    console.log(error)
                })

            },

            createMarkers(){
                // hide any markers from both scrapedData and retailerData if any marker is within lat and lng range of 0.0001
                let scrapedData = this.scrapedData
                let retailerData = this.retailerData
                let map = this.$refs.map.$mapObject


                for (let m of scrapedData){
                    for (let n of retailerData){

                        if (Math.abs(parseFloat(m.lat) - n.position.lat) < 0.001 && Math.abs(parseFloat(m.lng) - n.position.lng) < 0.001){
                            // remove n from retailerData and m from scrapedData and break from second loop
                            n.scrapedId = m.id
                            this.matchedMarkers.push(n)
                            if(this.hideMatching){
                                retailerData = retailerData.filter(item => item !== n)
                                scrapedData = scrapedData.filter(item => item !== m)
                                this.hiddenScrapedData.push(m)
                            }
                            break;
                        }
                    }
                }

                for (let m of scrapedData){
                    this.createScrapedMarker(m).setMap(map);
                }
                

                for (let m of retailerData){
                    this.createRetailerMarker(m).setMap(map);
                }
            },

            getDistance(a, b) {
                const latDiff = a.lat - b.lat;
                const lngDiff = a.lng - b.lng;
                return Math.sqrt(latDiff * latDiff + lngDiff * lngDiff);
            },

            mapUpdate(){
                if (this.updateCooldown){
                    return;
                }else{
                    this.updateCooldown = true;
                    setTimeout(() => {
                        this.updateCooldown = false;
                    }, 1000);
                    this.updateRPDMarkers()
                }
            },

            updateRPDMarkers(){
                // if (this.showRPDMarkers){
                //     let map = this.$refs.map.$mapObject
                //     let bounds = map.getBounds()
                //     let rpdData = this.rpdData.filter(item => bounds.contains(new google.maps.LatLng(item.position)))

                //     let OOBMarkers = this.rpdMarkers.filter(item => !bounds.contains(item.getPosition()))
                //     let inBoundsMarkers = this.rpdMarkers.filter(item => bounds.contains(item.getPosition()))

                //     // clear all OOB markers
                //     for (let m of OOBMarkers){
                //         this.rpdMarkers = this.rpdMarkers.filter(item => item !== m)
                //         m.setMap(null);
                //     }
                //     // add rpd data markers until rpdMarkers has 500 markers, skip over markers in inBoundsMarkers
                //     for (let m of rpdData){
                //         if (this.rpdMarkers.length < 500){
                //             // check if m is in inBoundsMarkers and if m does not have matching id in retailerData
                //             if (!inBoundsMarkers.includes(m) && !this.retailerData.find(item => item.id === m.id)){
                //                 this.createRPDMarker(m).setMap(map);
                //             }
                //         } else {
                //             break;
                //         }
                //     }

                 
                // } else {
                //     this.clearRPDMarkers()
                // }

                if (!this.showRPDMarkers) {
                    this.clearRPDMarkers();
                    return;
                }

                let bounds = this.$refs.map.$mapObject.getBounds();
                let zoom = this.$refs.map.$mapObject.getZoom();
                // break if zoom is less than 15
                if (zoom < 10) {
                    this.clearRPDMarkers();
                    return false;
                }

                // make map coordinates request with sw_lat, sw_lng, ne_lat, ne_lng
                this.$http.get('/map/coordinates', {
                    params: {
                        types: ['Leisure', 'Out of town', 'Shopping centres', 'Standalone'],
                        sw_lat: bounds.getSouthWest().lat(),
                        sw_lng: bounds.getSouthWest().lng(),
                        ne_lat: bounds.getNorthEast().lat(),
                        ne_lng: bounds.getNorthEast().lng(),
                    }
                }).then((response) => {
                    this.populateMarkers(response.data.data);
                }); 

            },  

            populateMarkers(markers){
                const map = this.$refs.map.$mapObject;
                const bounds = map.getBounds();

                // Filter RPD data within visible bounds
                const visibleRPDData = markers.filter(item =>
                    bounds.contains(new google.maps.LatLng(item.position))
                );

                // Separate current markers into in-bounds and out-of-bounds
                const inBoundsMarkers = [];
                const outOfBoundsMarkers = [];

                for (const marker of this.rpdMarkers) {
                    if (bounds.contains(marker.getPosition())) {
                    inBoundsMarkers.push(marker);
                    } else {
                    outOfBoundsMarkers.push(marker);
                    }
                }

                // Remove out-of-bounds markers from map and array
                for (const marker of outOfBoundsMarkers) {
                    marker.setMap(null);
                }

                // Keep only in-bounds markers in the marker list
                this.rpdMarkers = inBoundsMarkers;

                // Track existing marker IDs to prevent duplicates
                const existingMarkerIds = new Set(this.rpdMarkers.map(m => m.customId));
                const excludedIds = new Set(this.retailerData.map(item => item.id));

                // Add new markers up to 500
                for (const item of visibleRPDData) {
                    if (this.rpdMarkers.length >= 500) break;

                    if (!existingMarkerIds.has(item.id) && !excludedIds.has(item.id)) {
                    const marker = this.createRPDMarker(item);
                    marker.customId = item.id; // store the ID on the marker
                    marker.setMap(map);
                    this.rpdMarkers.push(marker);
                    }
                }
            },



            createScrapedMarker(marker){
                let markerData = {
                    position: {lat: parseFloat(marker.lat), lng: parseFloat(marker.lng)},
                    title: marker.address,
                    map: this.$refs.map.$mapObject,
                    icon: {
                        url: process.env.VUE_APP_BACKEND_BASE + 'img/rpd-marker-p.png',
                        scaledSize: new google.maps.Size(28.125, 36),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(14.05, 36),
                        labelOrigin: new google.maps.Point(14.0625, 44),
                    },
                    zIndex: 99999999,
                    draggable: true,
                    // label: {color: 'white', fontWeight: 'bold', fontSize: '13px', text: marker.name, className: "labels"},
                }
                let m = new google.maps.Marker(markerData);

                // const infoWindow = new google.maps.InfoWindow({
                //     content: `<div class="custom-info-window">${marker.address}</div>`,
                // });

                // const infoWindowExpanded = new google.maps.InfoWindow({
                //     content:`<div class="custom-info-window-expanded">
                //                 <b>Name: </b><span>${marker.name}</span><br/>
                //                 <b>Address: </b><span>${marker.address}</span><br/>
                //                 <b>Link: </b><a href="${marker.link}" target="_blank">${marker.link}</a><br/>
                //             </div>`,
                // });

                // Show the info window instantly on hover
                google.maps.event.addListener(m, 'mouseover', (event) => {
                    if (this.infoWindowExpanded.getMap()){
                        this.infoWindowExpanded.close();
                    }
                    let content = `<div class="custom-info-window">${marker.address}</div>`;
                    this.infoWindow.setContent(content);
                    this.infoWindow.open(this.$refs.map.$mapObject, m);
                });

                // Hide the info window when the mouse leaves
                
                google.maps.event.addListener(m, 'click', (event) => {
                    this.infoWindow.close();
                    let content = `<div class="custom-info-window-expanded">
                                    <b>Name: </b><span>${marker.name}</span><br/>
                                    <b>Address: </b><span>${marker.address}</span><br/>
                                    <b>Link: </b><a href="${marker.link}" target="_blank">${marker.link}</a><br/>
                                    <button type="button" id="set-error-link"  class="v-btn v-btn--plain theme--light v-size--small pl-0 pr-0"><span class="v-btn__content">Set Error <i aria-hidden="true" class="v-icon notranslate ml-1 mdi mdi-alert theme--light" style="font-size: 16px;"></i></span></button>
                                </div>`;
                    this.infoWindowExpanded.setContent(content);
                    this.infoWindowExpanded.open(this.$refs.map.$mapObject, m);

                    this.$nextTick(() => {
                        const link = document.getElementById('set-error-link');
                        if (link) {
                            link.addEventListener('click', (e) => {
                                e.preventDefault(); // Prevent default anchor behavior
                                this.setError(marker);
                            });
                        }
                    });
                    // if marker is unmatched, set index to markerIndex
                    if (this.unmatchedScrapedData.includes(marker)){
                        this.markerIndex = this.unmatchedScrapedData.indexOf(marker)
                    }
                });

                // on click outside of the info window, close the info window
                
                

                google.maps.event.addListener(m, 'mouseout', (event) => {
                    this.infoWindow.close();
                    // infoWindowExpanded.close();
                });

                google.maps.event.addListener(m, 'dragend', (event) => {
                    this.dragScrapedMarker(marker, event);
                });

                this.scrapedMarkers.push(m);
                return m;
            },

            createRetailerMarker(marker){
                let title = ''
                if(marker.scheme_name){
                    title += `${marker.scheme_name}, `
                }else if(marker.entity && marker.entity.data.scheme && marker.entity.data.scheme.data.name){
                    title += `${marker.entity.data.scheme.data.name}, `
                }
                if(marker.full_address){
                    title += marker.full_address
                }

                let markerData = {
                    position: {lat: marker.position.lat, lng: marker.position.lng},
                    title: title,
                    map: this.$refs.map.$mapObject,
                    icon: {
                        url: process.env.VUE_APP_BACKEND_BASE + 'img/rpd-marker-w.png',
                        scaledSize: new google.maps.Size(28.125, 36),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(14.05, 36),
                        labelOrigin: new google.maps.Point(14.0625, 44),
                    },
                    zIndex: 99999999,
                    draggable: true,
                    // label: {color: 'white', fontWeight: 'bold', fontSize: '13px', text: marker.name, className: "labels"},
                }
                if(marker.logo) {
                   markerData.icon = {

          url: 'https://rpd-public-' + (process.env.VUE_APP_ENV == 'production' ? 'files' : 'dev') + '.s3.eu-west-2.amazonaws.com/logos/' + marker.logo,
        }
                }

                let m = new google.maps.Marker(markerData);
                
                // const infoWindow = new google.maps.InfoWindow({
                //     content: `<div class="custom-info-window">${title}</div>`,
                // });

                // Show the info window instantly on hover
                google.maps.event.addListener(m, 'mouseover', (event) => {
                    let content = `<div class="custom-info-window">${title}</div>`;
                    this.infoWindow.setContent(content);
                    this.infoWindow.open(this.$refs.map.$mapObject, m);
                });

                // Hide the info window when the mouse leaves
                google.maps.event.addListener(m, 'mouseout', (event) => {
                    this.infoWindow.close();
                });

                google.maps.event.addListener(m, 'dragend', (event) => {
                    this.dragRetailerMarker(marker, event);
                });                                       

                google.maps.event.addListener(m, 'click', () => {
                    this.$refs.editPropertyDialog.showDialog(marker.entity_id);
                });

                this.retailerMarkers.push(m);
                return m;
            },

            createRPDMarker(marker){
                let imagePath
                if(marker.entity_type === 'property'){
                    imagePath = process.env.VUE_APP_BACKEND_BASE + 'img/rpd-marker-b.png'
                    
                }else if(marker.entity_type === 'scheme'){
                    imagePath = process.env.VUE_APP_BACKEND_BASE + 'img/rpdmarker-red.png'
                }

                let title = ''
                if(marker.scheme_name){
                    title += `${marker.scheme_name}, `
                }else if(marker.entity && marker.entity.data.scheme && marker.entity.data.scheme.data.name){
                    title += `${marker.entity.data.scheme.data.name}, `
                }
                if(marker.full_address){
                    title += marker.full_address
                }

                let markerData = {
                    position: marker.position,
                    title: title ? title : undefined,
                    map: this.$refs.map.$mapObject,
                    icon: {
                        url: imagePath, 
                        scaledSize: new google.maps.Size(28.125, 36),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(14.05, 36),
                        labelOrigin: new google.maps.Point(14.0625, 44),
                    },
                    draggable: false,
                    // label: {color: 'white', fontWeight: 'bold', fontSize: '13px', text: marker.name, className: "labels"},
                }

                if(marker.logo) {
                    // markerData.icon = {url: process.env.VUE_APP_BACKEND_BASE + marker.logo, size: new google.maps.Size(40, 40),};
                    markerData.icon = {
                        url: 'https://rpd-public-' + (process.env.VUE_APP_ENV == 'production' ? 'files' : 'dev') + '.s3.eu-west-2.amazonaws.com/logos/' + marker.logo,
                    }
                }
                
            
                let m = new google.maps.Marker(markerData);

                if(title){
                    // const infoWindow = new google.maps.InfoWindow({
                    //     content: `<div class="custom-info-window">${title}</div>`,
                    // });
                    google.maps.event.addListener(m, 'mouseover', (event) => {
                        let content = `<div class="custom-info-window">${title}</div>`;
                        this.infoWindow.setContent(content);
                        this.infoWindow.open(this.$refs.map.$mapObject, m);
                    });
                    google.maps.event.addListener(m, 'mouseout', (event) => {
                        this.infoWindow.close();
                    });
                }
                
                if(marker.entity_type === 'property'){
                    google.maps.event.addListener(m, 'click', () => {
                        this.$refs.editPropertyDialog.showDialog(marker.entity_id);
                    });
                }else if(marker.entity_type === 'scheme'){
                    google.maps.event.addListener(m, 'click', () => {
                        this.$refs.editSchemeDialog.showDialog(marker.entity_id, false);
                    });
                }
                
                this.rpdMarkers.push(m);
                return m;
            },

            addMarker(event) {
                if(!this.placingMarker) {
                    return;
                }
                // Add a new marker at the clicked location
                this.propertyMarker = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                };
                this.getAddress();
            },

            selectAddress(){
                let address = {
                    street: this.propertyAddress.line1,
                    street2: this.propertyAddress.line2,
                    city: this.propertyAddress.city,
                    region: this.propertyAddress.state,
                    post_code: this.propertyAddress.zip,
                    country: this.propertyAddress.country,
                    notes: '',
                    latitude: this.propertyMarker.lat,
                    longitude: this.propertyMarker.lng
                }

                let tenant = this.entity.clientCompany.data
                let prefill = {
                    address: address,
                    company_id: tenant,
                }

                if(this.propertyType === 'scheme') {
                    this.$refs.addSchemeDialog.openDialog(address, this.propertyMarker);
                } else {
                    this.$refs.addPropertyDialog.openDialog(prefill);
                }
            },

            dragPropertyMarker(e) {
                // Update the marker position
                this.propertyMarker = {
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng()
                };
                this.getAddress();
            },

            dragScrapedMarker(marker, e, undoing = false) {
                let originalMarker = {
                    marker: marker,
                    e: {
                        latLng: {
                            lat: parseFloat(marker.lat),
                            lng: parseFloat(marker.lng)
                        }
                    },
                }

                this.$http.put(`/scrapers/links/${marker.id}/position`, {
                    lat: undoing ? e.latLng.lat : e.latLng.lat(),
                    lng: undoing ? e.latLng.lng : e.latLng.lng()
                }).then(response => {
                    marker.lat = undoing ? e.latLng.lat : e.latLng.lat()
                    marker.lng = undoing ? e.latLng.lng : e.latLng.lng()

                    this.scrapedData = this.scrapedData.map(item => {
                        if (item.id === marker.id){
                            return marker
                        }
                        return item
                    })

                    // add original marker to edit history, where the index is, and clear everything after the index
                    if(!undoing){
                        let newMarker = {
                            marker: marker,
                            e: {
                                latLng: {
                                    lat: e.latLng.lat(),
                                    lng: e.latLng.lng()
                                }
                            },
                        }

                        this.pushToHistory(originalMarker, newMarker, 'scraped')
                    }

                    this.clearMarkers()
                    this.createMarkers()
                }).catch(error => {
                    this.$notify.error("Error updating position, if this persists, please contact support")
                    console.log(error)
                })
            },

            async dragRetailerMarker(marker, e, undoing) {     
                let originalMarker = {
                    marker: marker,
                    e: {
                        latLng: {
                            lat: parseFloat(marker.position.lat),
                            lng: parseFloat(marker.position.lng)
                        }
                    },
                    type: 'retailer'
                }
                this.$http.put(`properties/${marker.entity_id}/position`, {
                    lat: undoing ? e.latLng.lat : e.latLng.lat(),
                    lng: undoing ? e.latLng.lng : e.latLng.lng()
                }).then(response => {
                    marker.position = {
                        lat: undoing ? e.latLng.lat : e.latLng.lat(),
                        lng: undoing ? e.latLng.lng : e.latLng.lng()
                    }
                    this.retailerData = this.retailerData.map(item => {
                        if (item.entity_id === marker.entity_id){
                            return marker
                        }
                        return item
                    })

                    // add original marker to edit history, where the index is, and clear everything after the index
                    if(!undoing){
                        let newMarker = {
                            marker: marker,
                            e: {
                                latLng: {
                                    lat: e.latLng.lat(),
                                    lng: e.latLng.lng()
                                }
                            },
                            type: 'retailer'
                        }

                        this.pushToHistory(originalMarker, newMarker, 'retailer')
                    }

                    this.clearMarkers()
                    this.createMarkers()
                }).catch(error => {
                    this.$notify.error("Error updating position, if this persists, please contact support")
                    console.log(error)
                })
            },

            pushToHistory(oldMarker, newMarker = null, type){
                 // Remove all history after the current index if we are making a new edit
                if (this.editHistoryIndex < this.editHistory.length - 1) {
                    this.editHistory = this.editHistory.slice(0, this.editHistoryIndex + 1);
                }
                this.editHistory.push({
                    oldMarker: oldMarker,
                    newMarker: newMarker || oldMarker,  // If no newMarker, we default to oldMarker
                    type: type
                });

                this.editHistoryIndex++;
            },


            toggleMatching(){
                this.hideMatching = !this.hideMatching
                // clear all markers


                this.clearMarkers()
                this.createMarkers()
            },

            toggleListMatching(){
                this.hideListMatching = !this.hideListMatching
                
                // if index is now out of bounds, move it to the last index
                if (this.markerIndex >= this.scraperListData.length && this.scraperListData.length > 0){
                    this.markerIndex = this.scraperListData.length - 1
                }
            },

            addProperty(type) {
                if (type === 'scheme') {
                    this.placingMarker = true;
                    this.propertyType = 'scheme';
                } else {
                    this.placingMarker = true;
                    this.propertyType = 'standalone';
                }
            },

            async mapAdded(data){
                this.clearPropertyMarker()
                this.placingMarker = false;
                data.position = {
                    lat: data.address.latitude,
                    lng: data.address.longitude
                }
                data.entity_id = data.id

                // if the marker has the same tenant as the entity, then add the marker as a retailer otherwise add it as an rpd marker
                if(data.tenant && (data.tenant.id === this.entity.clientCompany.data.id)){
                    this.retailerData.push(data)
                    // refresh map
                    this.clearMarkers()
                    this.createMarkers()
                }else{
                    this.rpdData.push(data)
                    this.createRPDMarker(data).setMap(this.$refs.map.$mapObject);
                }

                //this.rpdData.push(data)

                //this.createRPDMarker(data).setMap(this.$refs.map.$mapObject);
                // this.getAllDataPaginated();

                // this.allMarkers
            },

            getAddress(autoSelect) {
                this.addressLoading = true;
                let latlng = { lat: this.propertyMarker.lat, lng: this.propertyMarker.lng };
                let geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'location': latlng }, (results, status) => {
                    if (status === 'OK') {
                    if (results[0]) {
                        const addressComponents = results[0].address_components;
                        this.propertyAddress = {
                            line1: '',
                            line2: '',
                            city: '',
                            state: '',
                            country: '',
                            zip: ''
                        };
                        const getComponent = (type) =>
                        addressComponents.find((component) => component.types.includes(type));

                        // Populate address fields
                        const streetNumber = getComponent('street_number');
                        const route = getComponent('route');
                        const locality = getComponent('locality');
                        const postalTown = getComponent('postal_town');
                        const adminArea = getComponent('administrative_area_level_1'); // State
                        const postalCode = getComponent('postal_code');
                        const country = getComponent('country');

                        // Assign values if the components are found
                        this.propertyAddress.line1 = streetNumber && route
                            ? `${streetNumber.long_name} ${route.long_name}`
                            : route
                            ? route.long_name
                            : '';
                        this.propertyAddress.city = locality ? locality.long_name : postalTown ? postalTown.long_name : '';
                        this.propertyAddress.state = adminArea ? adminArea.long_name : '';
                        this.propertyAddress.zip = postalCode ? postalCode.long_name : '';
                        this.propertyAddress.country = country ? country.long_name : '';
                        // delay 0.1s
                        setTimeout(() => {
                            this.addressLoading = false;
                            if (autoSelect) {
                                // this.selectAddress();
                            }
                        }, 100);
                    } else {
                        setTimeout(() => {
                        this.addressLoading = false;
                        }, 100);
                    }
                    } else {
                        console.log('Geocoder failed due to: ' + status);
                        setTimeout(() => {
                        this.addressLoading = false;
                        }, 100);
                    }
                });
                },

                schemeMarkerDeleted(data) {
                    // remove every scheme with data.id, or property with scheme_id = data.id
                    this.retailerData = this.retailerData.filter(item => item.scheme_id !== data.id);
                    this.rpdData = this.rpdData.filter(item => item.scheme_id !== data.id);
                    this.clearRPDMarkers();
                    this.updateRPDMarkers();
                    this.clearMarkers();
                    this.createMarkers();
                },

                propertyMarkerDeleted(data) {
                    // remove every property with data.id
                    this.retailerData = this.retailerData.filter(item => item.entity_id !== data.id);
                    this.rpdData = this.rpdData.filter(item => item.entity_id !== data.id || item.entity_type === 'scheme');
                    this.clearRPDMarkers();
                    this.updateRPDMarkers();
                    this.clearMarkers();
                    this.createMarkers();
                },


                clearPropertyMarker() {
                    this.propertyMarker = null;
                    this.propertyAddress = {
                        line1: '',
                        line2: '',
                        city: '',
                        state: '',
                        country: '',
                        zip: ''
                    }
                },

                clearMarkers(){
                    for (let m of this.scrapedMarkers){
                        m.setMap(null);
                    }
                    for (let m of this.retailerMarkers){
                        m.setMap(null);
                    }
                    this.scrapedMarkers = []
                    this.retailerMarkers = []
                    this.matchedMarkers = []
                },

                clearData(){
                    this.scrapedData = []
                    this.retailerData = []
                    // this.rpdData = []
                    this.editHistory = []
                    this.editHistoryIndex = -1  
                    this.markerIndex = 0
                    this.hiddenScrapedData = []
                },

                clearRPDMarkers(){
                    for (let m of this.rpdMarkers){
                        m.setMap(null);
                    }
                    this.rpdMarkers = []
                }
        },

        watch:{
            checkpoints:{
                handler: function(){
                    if (this.checkpoints.scrapedData && this.checkpoints.retailerData){
                        this.createMarkers()
                    }
                },
                deep: true
            },

            showRPDMarkers(){
                this.clearRPDMarkers()
                this.updateRPDMarkers()
            },

            'showMatching'(oldVal, newVal){
            //    match current marker index so that it follows the new data
                let currentIndex = this.markerIndex
                let target = this.scraperListData[currentIndex]
                if (target){
                    this.markerIndex = this.scrapedData.indexOf(target)
                }else{
                    this.markerIndex = 0
                }

            },

            'unmatchedScrapedData': {
                handler: function(){
                    // if index is now out of bounds, move it to the last index
                    if (this.markerIndex >= this.unmatchedScrapedData.length && this.unmatchedScrapedData.length > 0){
                        this.markerIndex = this.unmatchedScrapedData.length - 1
                    }
                },
                deep: true
            }
        },

        computed:{
            validAddress(){
                // return this.propertyAddress.line1 && this.propertyAddress.city && this.propertyAddress.state && this.propertyAddress.zip;
                return this.propertyAddress.line1 || this.propertyAddress.city || this.propertyAddress.state
            },

            compiledAddress(){
                let address = '';
                if(this.propertyAddress.city) {
                    address += this.propertyAddress.city + ', ';
                }
                if (this.propertyAddress.state && this.propertyAddress.zip) {
                    address += this.propertyAddress.state + ' ' + this.propertyAddress.zip + ', ';

                }else if(this.propertyAddress.state) {
                    address += this.propertyAddress.state + ', ';
                }else if (this.propertyAddress.zip) {
                    address += this.propertyAddress.zip + ', ';
                }
                if(this.propertyAddress.country) {
                    address += this.propertyAddress.country;
                }

                return address;
            },

            unmatchedScrapedData(){
                return this.scrapedData.filter(item => !this.hiddenScrapedData.includes(item))
            },

            scraperListData(){
                let data = []
                if(this.hideListMatching){
                    data = this.unmatchedScrapedData
                }else{
                    data = this.scrapedData
                }

                return data
            },

            searchListData(){
                let data = this.scraperListData
                // map index, eg scraperListData[10] = searchListData[0].index = 10
                data = data.map((item, index) => {
                    return {
                        ...item,
                        index: index
                    }
                })

                // filter data by search query
                if (this.searchQuery && this.searchQuery.length > 0) {
                    data = data.filter(item => {
                        return item.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                               item.address.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                               item.link.toLowerCase().includes(this.searchQuery.toLowerCase())
                    })
                }

                return data
            }
        },

        mounted(){
            // this.getAllMarkers()
        }
    }
</script>

<style>
    
</style>